import React from 'react'
import { H1, H2, HEADING_TYPES } from '../../../Heading/index'

function EnUs () {
  const infoEmailLink = <a href="mailto:info@gaia.com">info@gaia.com</a>
  const privacyEmailLink = <a href="mailto:Privacy@Gaia.com">Privacy@Gaia.com</a>

  const privacyLastUpdated = 'September 11, 2025'

  /* eslint-disable */

  return (
    <div className="policy">
      <H1 className="policy__banner-title">
        Terms of Use, Privacy, Policies
      </H1>
      {/* Terms of Use section */}
      <section className="policy__section">
        <H2 as={HEADING_TYPES.H5} className="policy__section-title" id="terms-of-use">
          Terms of Use
        </H2>
        <p className="policy__content policy__content--italic">
          (Including Privacy Policy for Children’s Online Privacy Protection
        </p>
        <p className="policy__content policy__content--italic">
          and “Your Privacy Rights” for California Residents)
        </p>
        <p className="policy__content policy__content--italic">
          Effective on 4 February 2026.
        </p>
        <p className="policy__content">
          Welcome to the Gaia websites, which are owned and operated by Gaia,
          Inc., a Colorado corporation, and its affiliates (collectively, the
          “Websites”).
        </p>
        <p className="policy__content">
          The Websites may include some or all of the following: (a) a
          platform for the purchase and use of digital content, which allows
          end-users to purchase a subscription and stream pre-recorded audio
          and video content over the Internet for personal use, (b) an
          e-commerce site, which allows users to purchase products from the
          Gaia online store, and (c) one or more websites where other online
          content (including content provided by Gaia, Website users and third
          parties), resources, tools, products, services, communications and
          social networking features may be accessed and used. All of the
          foregoing are collectively referred to as the “Services.”
        </p>
        <p className="policy__content">
          <strong>
            PLEASE READ VERY CAREFULLY ALL OF THE FOLLOWING TERMS AND
            CONDITIONS FOR USE OF THE WEBSITES. BY ACCESSING AND/OR USING THE
            WEBSITES, YOU ARE AGREEING TO BE BOUND BY ALL OF THE FOLLOWING
            TERMS OF USE AND PRIVACY POLICY.
          </strong>
        </p>
        <p className="policy__content">
          <strong>1. Parties.</strong> The following Terms of Use and Privacy
          Policy, as well as any other guidelines, rules or operating policies
          that Gaia may establish and post at the Websites from time to time,
          all of which are hereby incorporated by reference. All of the
          foregoing, which are collectively referred to as the{' '}
          <strong>"Agreement,”</strong> set forth the terms and conditions of
          a legally binding contract between each visitor to and/or user of
          the Websites (together with any business, entity or organization
          each such visitor and/or user may be representing) (referred to as
          “you” or “your”) and Gaia, Inc. (“Gaia,” “we,” “our” and “us”).
        </p>
        <p className="policy__content">
          <strong>
            2. Acceptance of Terms and Agreement to Be Bound.
          </strong>{' '}
          The Services are offered to you on the condition that you accept and
          agree to be bound by this Agreement in its entirety without
          modification of any kind. By accessing and/or using any of our
          Websites, you agree to be bound by this Agreement, whether you are a{' '}
          <strong>"Visitor"</strong> (which means that you simply browse one
          or more of our Websites) or you are a{' '}
          <strong>"Registered User"</strong> (which means that you have
          registered to use the Websites and have subscribed to use one or
          more of the Services). If you do not accept the terms of this
          Agreement, you are not permitted to use the Websites and/or
          subscribe to the Services, and you are obliged to exit all of the
          Websites and discontinue any and all use of the Websites and the
          Services immediately.
        </p>
        <p className="policy__content">
          <strong>3. Modifications.</strong> We may modify this Agreement from
          time to time, and, to the greatest extent permitted by law, such
          modifications shall be effective upon posting at any of our
          Websites. By accessing and/or using any of our Websites after any
          such modification is posted, you are agreeing to be bound by such
          modifications. You also acknowledge and agree that it is your
          responsibility to monitor the Websites for the posting of
          modifications and to review such modifications on a regular basis.
          If you do not agree to be bound by any future modifications of this
          Agreement, your exclusive remedy is to cancel your account and
          discontinue your use of the Websites and the Services. Except as
          otherwise expressly provided herein, any new features, tools,
          products and/or services that change, augment, enhance or upgrade
          the current Websites and/or the Services will be subject to this
          Agreement.
        </p>
        <p className="policy__content">
          <strong>4. General Registration Requirements.</strong> Visitors are
          currently permitted to view only limited portions of the Websites
          prior to deciding whether to become a Registered User. Full access
          to the Websites and the Services is available only to Registered
          Users and, if a subscription is required, then only to Registered
          Users who are also paid subscribers. If you wish to become a
          Registered User, you must register on our Websites, you must
          complete the registration procedures displayed on the registration
          page(s) of the Websites and, where applicable, pay the required
          subscription fee. Some aspects of the Websites and the Services are
          available to all Registered Users, and some are available only to
          Registered Users who have paid the required subscription fee and/or
          other charges, all of which are posted at the Websites.
        </p>
        <p className="policy__content">
          <strong>
            5. Age Requirements for Access and Use of the Websites.
          </strong>{' '}
          By accessing and using the Websites, you acknowledge and agree that
          you are representing to us that you are over the age of 18 and you
          are of legal age to form a legally binding contract, and you are not
          a person barred from purchasing or receiving products and services,
          under the laws of the United States or other applicable
          jurisdiction. Registration, subscription, access to and use of the
          Websites and the Services are not available to users under the age
          of 18 and are void where prohibited by applicable law.
        </p>
        <p className="policy__content">
          <strong>6. Requirements for Becoming a Registered User.</strong> By
          completing the registration procedures displayed on the registration
          page(s) of the Websites, you acknowledge and agree that (a) you are
          representing to us that you are providing true, accurate, current
          and complete information about yourself as prompted by the
          registration form available on our Websites (the{' '}
          <strong>"Registration Data"</strong>), and (b) you are obliged to
          maintain and promptly update your Registration Data to keep it true,
          accurate, current and complete. If you provide any information that
          is untrue, inaccurate, not current or incomplete, or we have
          reasonable grounds to suspect that such information is untrue,
          inaccurate, not current or incomplete, we reserve the right to
          suspend or terminate your account and refuse any and all current or
          future access to and/or use of the Websites and the Services (or any
          portion thereof).
        </p>
        <p className="policy__content">
          <strong>7. Children.</strong> Due to the nature of the Internet, we
          cannot prohibit minors from visiting our Websites. However, our
          Websites are not directed toward children under the age of 13 and we
          do not knowingly collect information from children under the age of
          13 through the Websites. If you believe that a child has provided
          information to us through the Websites, please contact us by email
          at info@gaia.com or by writing us at Gaia, Inc. 833 W. South Boulder
          Road, Louisville, Colorado 80027, Attn.: Director of Operations. We will use our
          best efforts to remove all of the information provided by the child
          from our system. (See our Privacy Policy set forth below for
          additional information about Children’s Online Privacy Protection
          Policy.
        </p>
        <p className="policy__content">
          <strong>8. Member Account, Password and Security.</strong> As a
          Registered User, you are required to choose a password, and provide
          your email address, and you may be asked
          for additional information regarding your account. You are
          responsible for maintaining the confidentiality and security of the
          password and all other account information, and you are fully
          responsible and liable for all access to and use of the Websites and
          the Services that occur under your password or account. You agree to
          (a) immediately notify us by e-mail to info@gaia.com of any
          unauthorized use of your password or account or any other breach of
          security, and (b) ensure that you log out from your account at the
          end of each session. Gaia will not be liable for any loss or damage
          arising from your failure to comply with this section.
        </p>
        <p className="policy__content">
          <strong>
            9. Preservation and Disclosure of Account Information and User
            Content.
          </strong>{' '}
          You acknowledge and agree that Gaia may access, preserve and
          disclose your account information and User Content if required to do
          so by law or in a good faith belief that such access, preservation
          or disclosure is reasonably necessary to: (a) comply with legal
          process; (b) enforce this Agreement; (c) respond to claims that any
          Site Content violates the rights of third parties; (d) respond to
          your requests for customer service; or (e) protect the rights,
          property or personal safety of Gaia, the other users of the Websites
          and Services, and the public. However, under no other circumstances
          will Gaia intentionally disclose your account information to any
          third party except as otherwise provided in our Privacy Policy,
          which is set forth below.
        </p>
        <p className="policy__content">
          <strong>10. Security Components.</strong> You acknowledge and agree
          that the Websites and the Services, and the software embodied within
          the Websites and the Services, may include security components that
          permit digital materials to be accessed, used, and protected, and
          that use of these security components is subject to usage rules set
          by Gaia and/or content providers who provide content to Gaia. You
          may not attempt to override or circumvent any such security
          components and usage rules embedded in the Websites and the
          Services.
        </p>
        <p className="policy__content">
          <strong>11. Subscription Fees and Payment.</strong> Access to and
          use of the Services is subject to a subscription fee (<strong>"Fee"</strong>).
          The Fee is payable in U.S. dollars or other currency as applicable.
          You will be required to provide your credit card number and other
          information at the time of your initial registration. Your credit
          card will automatically be charged at the time of your subscription
          or the end of your free trial, and regularly thereafter based on the
          terms of your subscription, and you hereby authorize Gaia to charge
          your credit card for the then-applicable subscription fee. The Fee
          is non-refundable except as provided in Section 26 below (“Term and
          Termination”). Gaia reserves the right to change or modify the Fee
          or payment schedule (including, without limitation, increasing
          prices and charging a fee for upgrades) at any time. Plans priced in
          currencies other than U.S. dollars are subject to adjustment due to
          fluctuations in exchange rates. Gaia will use its reasonable best
          efforts to provide you with reasonable notice prior to making any
          fee changes or modifications, with the exception of exchange rate
          changes.
        </p>
        <p className="policy__content">
          Free trial eligibility is determined by Gaia at its sole discretion
          and we may limit eligibility or duration to prevent free trial abuse.
          We reserve the right to revoke the free trial and put your account
          on hold in the event that we determine that you are not eligible.
          Members of households with an existing or recent Gaia  membership are
          not eligible. We may use information such as device ID, method of
          payment or an account email address used with an existing or recent
          Gaia  membership to determine eligibility. For combinations with other
          offers, restrictions may apply.
        </p>
        <p className="policy__content">
          If Gaia is for any reason unable to effect automatic payment via
          your credit card, Gaia will attempt to notify you via email and your
          account will be disabled until payment is received. You are
          responsible for notifying Gaia of any changes to your credit card
          information and to update your information if your credit card has
          expired. Gaia may suspend, terminate and/or otherwise interrupt your
          access to the Services if you fail to so notify Gaia.
        </p>
        <p className="policy__content">
          All Fees are exclusive of all excise, sales, use, transfer and other
          taxes and duties imposed with respect to the Services by any
          federal, state, municipal or other governmental authority, all of
          which taxes you are required to pay except for taxes based on Gaia’s
          net income. You are responsible for obtaining and providing to Gaia
          any certificate of exemption or similar document required to exempt
          any transaction from sales, use or similar tax liability.
        </p>
        <p className="policy__content">
          You agree to pay your account balance on time. You are responsible
          and liable for any costs and expenses, including attorney and
          collection fees, that Gaia may incur in its efforts to collect any
          remaining balances due from you. This paragraph will in no way limit
          any other remedies available to Gaia. You are required to notify us
          of any billing problems or discrepancies within sixty (60) days
          after they first appear on your credit card account statement by
          sending a written notice to info@gaia.com. If you do not so notify
          us within the time allowed, you waive any right to dispute such
          problems or discrepancies.
        </p>
        <p className="policy__content">
          We will send you information relating to your account (e.g. payment
          authorizations, invoices, changes in password or Payment Method,
          confirmation messages, notices) in electronic form only, for example
          via emails to your email address provided during registration. You
          agree that any notices, agreements, disclosures or other
          communications that we send to you electronically will satisfy any
          legal communication requirements, including that such communications
          be in writing.
        </p>
        <p className="policy__content">
          <strong>12a. Content.</strong> The content available at the Websites
          and the Services generally consists of (a) content owned by Gaia,
          including but not limited to the trademarks, trade dress and “look
          and feel” of the Websites and content created and/or acquired and
          owned by Gaia (<strong>“Gaia Content”</strong>), (b) content owned
          by third parties and licensed to Gaia for specified uses on the
          Websites and the Services (<strong>“Third-Party Content”</strong>),
          and (c) content that may be posted and/or otherwise uploaded to the
          Websites and/or the Services by you (<strong>“User Content”</strong>).
          As between you and other Registered Users, however, the content
          posted by other Registered Users is considered to be “Third-Party
          Content.” All of the foregoing are collectively referred to as{' '}
          <strong>“Site Content.”</strong> The quality of the display of the
          Gaia content may vary from device to device, and may be affected by
          a variety of factors, such as your location, the bandwidth available
          through and/or speed of your Internet connection. Please check with
          your Internet provider for information on possible Internet data
          usage charges. Gaia makes no representations or warranties about
          the quality of your watching experience on your display.
        </p>
        <p className="policy__content">
          <strong>12b. Geographic Limitations.</strong> Due to certain
          licensing restrictions placed on our titles, some content may not be
          available in your geographic location, and therefore, cannot be
          viewed. If at any time you feel this inhibits your experience upon
          purchasing a Gaia subscription, please contact our customer service
          department and we will work with you in order to remedy the
          situation. You can reach customer service by email at info@gaia.com.
        </p>
        <p className="policy__content">
          <strong>13. Ownership of Content.</strong> Gaia does not claim
          ownership rights in any User Content that you post on the Websites
          or otherwise make available through the Services. Subject to the
          non-exclusive license contained in Section 14 below (“License to
          Your Content”), as between Gaia and you, you will retain all
          intellectual property rights that you may have in any User Content
          that originates with you.
        </p>
        <p className="policy__content">
          <strong>14a. License to Your Content.</strong> In order to be able to
          offer you the use of our Websites and the Services pursuant to this
          Agreement, you are required to grant a license to Gaia to your User
          Content. Accordingly, by posting, displaying, publishing,
          transmitting, or otherwise making available (individually and
          collectively, "posting") any User Content on or through our Websites
          or the Services, other than Chatbot Content when received and
          generated through chatbots, you hereby grant to Gaia a non-exclusive
          (meaning you can license the User Content to other parties as well),
          fully-paid, royalty-free, perpetual, irrevocable, worldwide license
          (including the right to sublicense) to use, copy, modify, adapt,
          translate, create derivative works, publicly perform, publicly
          display, store, reproduce, transmit, distribute, and otherwise make
          available such User Content on and through the Websites and/or the
          Services, in print, or in any other format or media now known or
          hereafter invented, without any obligation of notification,
          compensation, attribution or consent. Notwithstanding the
          foregoing, we will not use your User Content to create
          commercial products such as books. For purposes of this section,
          “commercial products” does not include use on the Websites and the
          Services and/or the advertising, publicity, promotional and
          marketing materials for the Websites and the Services in any and all
          formats and media now known or hereafter invented. If you wish to
          remove any User Content from the Websites and/or the Services, the
          decision will be made by Gaia alone in its sole and absolute
          discretion, and our decision may depend on the type of User Content,
          the location and manner of posting, and other factors. You may
          contact us at info@gaia.com to request the removal of certain User
          Content you have posted, but Gaia (i)has no obligation to remove any
          such User Content, (ii)may choose whether or not to do so in its
          sole discretion, and (iii)makes no guarantee as to the complete
          deletion of any such User Content and copies thereof. In any case, a
          back-up or residual copy of any User Content posted by you may
          remain on Gaia’s servers after the User Content appears to have been
          removed from the Websites and/or the Services, and Gaia retains all
          rights granted in this section to all such remaining copies. You
          represent and warrant that: (i) you own all right, title and
          interest in all User Content posted by you on or through our
          Websites or the Services, or otherwise have the right to grant the
          license set forth in this section, and (ii) the posting of your User
          Content on or through the Websites and/or the Services does not
          require the knowledge or consent of any third party and does not
          violate the privacy rights, publicity rights, copyrights,
          trademarks, patents, trade secrets, contract rights,
          confidentiality, or any other rights of any third party.
        </p>
        <p className="policy__content">
          <strong>14b. Chatbot Usage.</strong> In connection with use of the
          Website and the Services you may have the ability to interact with
          chatbots by providing input in various forms (“Chatbot Input”), and
          you may receive output based on the Input (“Chatbot Output” and with
          Chatbot Input, “Chatbot Content”). You grant Gaia a non-exclusive,
          worldwide, royalty-free, fully paid, transferable, and sublicensable
          license to use, reproduce, process, adapt, modify, translate,
          analyze, create derivative works from, and otherwise exploit your
          Chatbot Content as necessary to: (a) operate, maintain, develop, and
          improve Gaia’s and its affiliates’ products, including the Websites
          and the Services; and (b) market, promote, and offer other Gaia
          products and services to you based on Chatbot Content. Gaia will not
          publicly disclose, sell, or otherwise share your Chatbot Content
          except as necessary to comply with applicable law, or to enforce its
          rights under these terms.
        </p>
        <p className="policy__content">
          <strong>15. Prohibited Conduct.</strong> The Websites and the
          Services may include features that permit you to post User Content,
          which includes and applies to (but is not limited to) content of
          your own, comments on the User Content posted by other Registered
          Users, and communications with other Registered Users. Such User
          Content includes but is not limited to information, data, text,
          software, music, sound, photographs, graphics, video, messages,
          tags, or other materials. You acknowledge and agree that you shall
          not use the Websites and/or the Service to post or other transmit
          User Content that:
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              is patently offensive and/or promotes racism, bigotry, hatred or
              physical harm of any kind against any group or individual;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              harasses or advocates harassment of another person;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              exploits people in a sexual or violent manner;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              contains nudity, violence, or offensive subject matter;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              solicits personal information from anyone under the age of
              eighteen (18);
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              provides any telephone numbers, street addresses, last names or
              email addresses of anyone other than your own;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              promotes information that you know is false or misleading or
              promotes illegal activities or conduct that is abusive,
              threatening, obscene, defamatory or libelous;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              violates any intellectual property or other proprietary right of
              any third party, including User Content that promotes an illegal
              or unauthorized copy of another person's copyrighted work, such
              as providing pirated computer programs or links to them,
              providing information to circumvent manufacture-installed
              copy-protect devices, or providing pirated music or links to
              pirated music files;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              involves the transmission of "junk mail," "chain letters," or
              unsolicited mass mailing, instant messaging, "spimming," or
              "spamming";
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              contains restricted or password only access pages or hidden
              pages or images (those not linked to or from another accessible
              page);
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              furthers or promotes any criminal activity or enterprise or
              provides instructional information about illegal activities
              including, but not limited to making or buying illegal weapons,
              violating someone's privacy, or providing or creating computer
              viruses;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              solicits passwords or personal identifying information for
              commercial or unlawful purposes from other Members;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              involves commercial activities and/or sales without our prior
              written consent, such as contests, sweepstakes, barter,
              advertising, or pyramid schemes;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              includes a photograph of another person that you have posted
              without that person's consent or, in the case of children under
              the age of eighteen (18), parental consent, or otherwise
              constitutes an invasion of an individual's privacy or
              infringement of publicity rights; or
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              contains a virus or other harmful component.
            </p>
          </li>
        </ul>
        <p className="policy__content">
          <strong>16. Responsibility for User Content.</strong> You, and not
          Gaia, are entirely responsible for all User Content that you upload,
          post, email, transmit or otherwise make available via the Websites
          and/or the Services. Gaia does not control the User Content posted
          via the Websites and/or the Services and, as such, we cannot and do
          not guarantee the accuracy, integrity or quality of such User
          Content. You acknowledge and agree that, by using the Websites and
          the Services, you may be exposed to User Content that you deem
          offensive, indecent or objectionable. Under no circumstances will
          Gaia be liable in any way for any User Content, including, but not
          limited to, any errors or omissions in any user Content, or any loss
          or damage of any kind incurred as a result of the use of any User
          Content posted, emailed, transmitted or otherwise made available via
          the Websites and/or the Services.
        </p>
        <p className="policy__content">
          <strong>17. Rejection and/or Removal of User Content.</strong> You
          acknowledge and agree that Gaia may or may not pre-screen User
          Content posted on our Websites, but that Gaia shall have the right
          (but not the obligation) in its sole discretion to pre-screen, edit,
          refuse, and/or remove any User Content or portion thereof that is
          available via the Websites and/or the Services, in its sole and
          absolute discretion, for any reason, including but not limited to
          its determination that any such User Content is not appropriate for
          the Websites and/or the Services, or for no reason. Without limiting
          the foregoing, and by way of example only, Gaia shall have the
          absolute right to remove from the Websites and/or the Services any
          User Content that violates this Agreement or is otherwise
          objectionable in the sole discretion of Gaia, or to restrict,
          suspend, or terminate your access to all or any part of the Websites
          and/or the Services at any time, for any or no reason, with or
          without prior notice, and without liability. If you become aware of
          misuse of the Websites and/or the Services by any person, please
          contact Gaia by email at info@gaia.com.
        </p>
        <p className="policy__content">
          <strong>18. Limited License.</strong> Gaia hereby grants to
          Registered Users a limited, personal, revocable, non-sublicensable
          license to display a single copy of the Gaia Content and the
          Third-Party Content located on or available through our Websites or
          Service (excluding any software code therein) solely for your
          single, personal, non-transferable and non-commercial use in
          connection with viewing our Websites and using the Services during
          the term of your registration. All such use is subject to the terms
          and conditions set forth in this Agreement and may be terminated by
          Gaia as set forth in this Agreement. Except for User Content posted
          by you, you may not copy, store, modify, translate, publish,
          broadcast, transmit, distribute, perform, display, make available,
          or sell any Site Content for any purpose whatsoever.
        </p>
        <p className="policy__content">
          <strong>19. Examples of Limitations on Use.</strong> Any
          non-commercial reuse of any portion of the Site Content by a
          Registered User that falls within what is allowed as “Fair Use”
          under the United States copyright and trademark law is permitted. In
          addition to the limitations set forth in Section 18 above (“Limited
          License”), and by way of example only, no commercial storage, use,
          reproduction or transmission of any Site Content is permitted under
          any circumstances. The Websites and the Services may not be used in
          connection for any commercial purposes except as specifically
          approved in writing and in advance by an authorized representative
          of Gaia. Unauthorized framing of or linking to any of our Websites
          is prohibited. Commercial advertisements and other commercial
          content, affiliate links, and other forms of solicitation may be
          removed by Gaia from the Websites and the Services without notice
          and may result in termination of registration and subscription and
          denial of access to and use of the Websites and the Services.
        </p>
        <p className="policy__content">
          <strong>20. Health and Medical Concerns.</strong> Some of the Site
          Content includes information and instruction relating to exercise
          and fitness, and some of the products and services available through
          the Websites and the Services relate to exercise and fitness. You
          acknowledge and agree that the following warnings and disclaimers
          shall apply to all such information, instruction, products and
          services.
        </p>
        <p className="policy__content">
          Before participating in any exercise program or using any fitness
          products or services that may be described and/or made accessible in
          or through the Website and/or the Services, we strongly recommend
          that you consult with a physician or other healthcare provider.
          Gaia, its staff and the content-providers are not licensed medical
          care providers, are not rendering personal medical advice or
          treatment, and have no expertise in advising on, diagnosing,
          examining, or treating medical conditions of any kind, or in
          determining the effect of any specific exercise on a medical
          condition.
        </p>
        <p className="policy__content">
          The Websites and the Services are not intended to be a substitute
          for professional medical advice, diagnosis, or treatment. You
          acknowledge and agree that when participating in any exercise or
          exercise program, and/or when using any fitness products or
          services, there is the possibility of physical injury and/or death,
          and you assume the risk and responsibility for any such results.
        </p>
        <p className="policy__content">
          You should never disregard medical advice or delay seeking it
          because of a statement you have read on the Websites and/or the
          Services. The Websites and the Services should not be used in lieu
          of advice given by qualified medical professionals such as your
          doctor or registered dietitian. It is important that the Websites
          and the Services are used only in conjunction with qualified medical
          guidance. If you know or suspect that you may be pregnant, have an
          eating disorder, have diabetes, or have any other physical or
          medical condition, it is imperative that you seek the advice of your
          doctor prior to using the Websites and/or the Services.
        </p>
        <p className="policy__content">
          You must always consult your doctor before beginning an exercise or
          dietary program. Keep the following checklist in mind when
          developing your program in conjunction with your health care
          provider, but also bear in mind that the checklist is not exhaustive
          and does not take the place of a consultation with your healthcare
          provider.
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              After exercise do you frequently experience chest pains?
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Do you get dizzy when you exercise?
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Are you breathless after exercising?
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Do you take medication for high blood pressure?
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Do you have joint problems?
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Do you have a medical condition, which might need special
              attention when exercising, for example diabetes?
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Have you been physically active in the past?
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Do you have a heart condition that requires supervised physical
              activity?
            </p>
          </li>
        </ul>
        <p className="policy__content">
          If you experience any discomfort or pain during an exercise routine
          you must immediately cease the activity and seek the assistance of a
          physician.
        </p>
        <p className="policy__content">
          <strong>21. Reservation of Rights.</strong> Gaia Content and
          Third-Party Content are protected by copyright, trademark, patent,
          trade secret and other laws. Gaia and its third-party licensors owns
          and retains their respective rights, title and interest in and to
          their respective content subject only to the limited licensed
          granted to Registered Users as set forth above.
        </p>
        <p className="policy__content">
          <strong>22. Other Sites.</strong> The Websites may contain
          third-party advertising and/or links to other sites owned by third
          parties (i.e. advertisers, affiliate partners, strategic partners,
          or others). However, the inclusion of a link in any of our Websites
          does not imply Gaia’s investigation, evaluation and/or endorsement
          of such third party website. We are not responsible for examining or
          evaluating, and we do not warrant the products or offerings of, any
          of these businesses, entities or individuals, or the accuracy of the
          content of their advertising or websites. Gaia does not assume any
          responsibility or liability for the actions, products, services,
          and/or content of any such websites. Before you purchase goods or
          services from a third party and/or use any third-party website, you
          should review the applicable terms of use and privacy policies for
          such websites. If you decide to access any such linked websites, you
          do so at your own risk.
        </p>
        <p className="policy__content">
          <strong>23. International Use.</strong> Due to the global nature of
          the Internet, you acknowledge and agree that you are obliged to
          comply with all applicable laws, rules and regulations regarding the
          access to and use of the Websites and the Services. By way of
          example only, you acknowledge and agree that you are obliged to
          comply with all applicable laws regarding the transmission of
          technical data exported from the United States or the country in
          which you reside, and that restrictions on access to and/or use of
          some Site Content may apply to users based on their place of
          domicile, residence and/or use.
        </p>
        <p className="policy__content">
          <strong>24. Take-Down Notices Under the DMCA.</strong> Gaia will
          receive and evaluate notices of copyright infringement and take
          appropriate actions under the Digital Millennium Copyright Act,
          Title 17, United States Code, Section 512(c)(2) (<strong>“DMCA”</strong>).
          Written notices of claimed copyright infringement must be in strict
          compliance with all terms and conditions of the DMCA and must be
          submitted according to the procedures set forth in the DMCA to the
          following Designated Agent for Gaia:
        </p>
        <p className="policy__content">
          <strong>
            Name of Agent Designated to Receive Notification of Claimed
            Infringement on Behalf of Gaia, Inc:
          </strong>{' '}
          Director of Content Acquisition and Content
        </p>
        <p className="policy__content">
          <strong>
            Full Address of Designated Agent to Which Notification to Gaia
            Should Be Sent:
          </strong>
        </p>
        <p className="policy__content">
          Director of Content Acquisition and Content<br /> Gaia, Inc.<br /> 833 W.
          South Boulder Road<br /> Louisville, CO 80027
        </p>
        <p className="policy__content">
          <strong>Email of Designated Agent:</strong> content.infringement@gaia.com
        </p>
        <p className="policy__content">
          <strong>25. Registered User Disputes.</strong> You are solely
          responsible for your interactions with other Registered Users. Gaia
          reserves the right, but has no obligation, to monitor disputes
          between you and other Registered Users.
        </p>
        <p className="policy__content">
          <strong>26. Term and Termination.</strong>
        </p>
        <p className="policy__content">
          This Agreement, as it may be modified from time to time, shall
          remain in full force and effect for so long as it is posted on any
          of the Websites or until terminated by Gaia or by you.
        </p>
        <p className="policy__content">
          You may terminate your status as a Registered User and cancel your
          account at any time and for any reason, by notifying us by email at
        info@gaia.com, but any such termination
          and cancellation will be effective only after Gaia has processed the
          request. If you cancel your account prior to the expiration of your
          pre-paid subscription period, you will forfeit the Fees paid for any
          unused portion of your subscription, which are non-refundable.
          However, you will be able to continue viewing premium content until
          the expiration of your current pre-paid subscription period. You
          also acknowledge and agree that the cancellation of your account is
          your sole right and remedy with respect to any dispute with Gaia.
        </p>
        <p className="policy__content">
          Gaia reserves the right to suspend or terminate your status as a
          Registered User, cancel your account, and disable your access to the
          Websites and Services at any time, with or without notice to you,
          with or without cause, and without liability to you. Gaia shall have
          no liability to you or any third party because of such suspension or
          termination or related action for any reason except as follows: (a)
          If Gaia elects do so with cause, then no refund of any unused
          portion of a pre-paid subscription is owing, and (b) if Gaia elects
          to do so without cause, then Gaia will refund any unused portion of
          a pre-paid subscription.
        </p>
        <p className="policy__content">
          The following sections shall survive any termination of this
          Agreement, your account, and/or your use of the Service: Section 9
          (“Preservation and Disclosure of Account Information and User
          Content”), Section 12 (“Content”), Section 13 (“Ownership of
          Content”), Section 14 (“License to Your Content”), Section 16
          (“Responsibility for Your User Content”), Section 17 (“Rejection
          and/or Removal of User Content”), Section 20 (“Health and Medical
          Concerns”), Section 21 (“Reservation of Rights”), Section 22 (“Other
          Sites”), Section 23 (“International Use”), Section 25 (“Registered
          User Disputes”), Section 27 (“Disclaimer of Warranties”), Section 28
          (“Waiver of Claims”), Section 29 (“Limitation of Liability”),
          Section 30 (“Severability”), Section 31 (“Indemnity”), and Sections
          34 through 40.
        </p>
        <p className="policy__content">
          Upon suspension or termination, Gaia shall have no obligation to
          save any User Content that you may have posted or otherwise
          provided, and we reserve the right to permanently delete and destroy
          any of your personal information and/or User Content.
        </p>
        <p className="policy__content">
          <strong>27. Disclaimer of Warranties.</strong> You acknowledge and
          agree that the Websites and the Services are offered without
          warranties of any kind whatsoever by Gaia and/or the providers of
          Site Content. The disclaimer of warranties includes, but is not
          limited to, the following.
        </p>
        <p className="policy__content">
          (a) Your use of the Websites and the Services is at your sole risk.
          The Websites and the Services are provided on an “as is” and “as
          available” basis. Gaia and its parent, subsidiaries, affiliates,
          successors and assigns, and their respective shareholders, officers,
          directors, employees, agents, partners, licensors, vendors and
          contractors (collectively, the{' '}
          <strong>“Gaia-Related Parties”</strong>) expressly disclaim all
          warranties of any kind, whether express or implied, including, but
          not limited to the implied warranties of merchantability, fitness
          for a particular purpose and non-infringement, with respect to the
          service, the websites, and any third party websites with which they
          are linked.
        </p>
        <p className="policy__content">
          (b) The Gaia-Related Parties are not responsible or liable for any
          loss, damage, injury or health problems that may result from your
          use of the Site Content and/or other aspects of the Websites and/or
          the Services, including but not limited to training programs,
          recipes, products, services, events and/or information that you may
          learn about on the Websites and/or the Services, and/or any action
          or inaction on your part as a result of information you have
          obtained from the Websites and/or the Services. By way of example
          only, if you engage in any exercise or diet program that you receive
          or learn about through the Websites and/or the Services, and/or if
          you use any product or service that you receive or learn about
          through the Websites and/or the Services, you agree that you do so
          voluntarily, after consulting an appropriate health professional of
          your choice, and at your own risk, and you agree to release and
          discharge the Gaia-Related Parties Gaia from any and all claims or
          causes of action, known or unknown, arising out of the foregoing.
        </p>
        <p className="policy__content">
          (c) The Gaia-Related Parties make no warranty that the Websites or
          the Services, the Site Content, and/or the information, products and
          services available through the Websites or the Service will meet
          your expectations or requirements, or that you will achieve any
          particular results from the use of any of the foregoing, or that the
          Websites or the Services will be uninterrupted, timely, secure,
          error-free, or free of any harmless components (including viruses,
          malware, spyware, or comparable components.
        </p>
        <p className="policy__content">
          (d) You expressly assume the risk, by way of example, of deletion,
          non-delivery or failure to store postings of User Content,
          communications, personalized settings, or data, and you acknowledge
          that the Gaia-Related Parties make no warranties regarding the
          foregoing.
        </p>
        <p className="policy__content">
          (e) Any material downloaded or otherwise obtained through the use of
          our Websites or the Services is accessed at your own discretion and
          risk, and you will be solely responsible for any loss or damage to
          your computer system or loss of data that results from the download
          of any such material.
        </p>
        <p className="policy__content">
          <strong>28. Waiver of Claims.</strong> You hereby waive, release and
          discharge the Gaia-Related Parties from and against any claims that
          you may be entitled to make by reason of any use of your User
          Content authorized under this Agreement and/or by reason of your
          participation in any of the communications and social networking
          features of the Services, including but not limited to, and by way
          of example only, any claims based on copyright infringement,
          trademark infringement, rights of privacy or publicity, defamation
          and otherwise.
        </p>
        <p className="policy__content">
          <strong>29. Limitation of Liability.</strong> To the fullest extent
          permitted by applicable laws, the Gaia-Related Parties will in no
          event be liable to you or any third party for any indirect,
          consequential, exemplary, incidental, special or punitive damages,
          including lost profit damages arising from or in connection with any
          use of the Websites and/or the Services, and/or any website with
          which they are linked, and/or any content, information, products or
          services accessible through the Websites and/or the Services, even
          if any of the Gaia-Related Parties have been advised of the
          possibility of such losses or damages. Notwithstanding anything to
          the contrary contained herein, the aggregate liability of the
          Gaia-Related Parties to you for any cause whatsoever and regardless
          of the form of the action, will at all times be limited to the
          amount paid, if any, by you to Gaia for the Services.
        </p>
        <p className="policy__content">
          <strong>30. Severability.</strong> Some jurisdictions do not allow
          the exclusion of certain warranties or the limitation or exclusion
          of liability for incidental or consequential damages. Accordingly,
          in certain jurisdictions, some of the above limitations of liability
          may not apply to you. In any such case, and/or if any terms or
          conditions of this Agreement are held to be invalid for any reason
          whatsoever, this Agreement shall remain in full force and effect on
          its remaining terms and conditions of this Agreement unless and
          until terminated by Gaia. Furthermore, if any term or condition of
          this Agreement is found by a court of competent jurisdiction to be
          invalid, the parties nevertheless agree that the court should
          endeavor to give effect to the intentions of the parties as
          reflected in the invalidated provision.
        </p>
        <p className="policy__content">
          <strong>31. Indemnity.</strong> You agree to indemnify, defend, and
          hold harmless the Gaia-Related Parties from any and all third party
          claims, losses, liability, damages, and/or costs (including
          reasonable attorney fees and costs) arising from your breach of the
          terms of this Agreement, or your infringement, or infringement by
          any other user of your account, of any intellectual property or
          other right of any person or entity. Gaia will use its reasonable
          best efforts to notify you promptly of any such claim, loss,
          liability, or demand, and will provide you with reasonable
          assistance, at your expense, in defending any such claim, loss,
          liability, damage, or cost.
        </p>
        <p className="policy__content">
          <strong>32. Additional Terms.</strong> We may also require you to
          follow additional rules, guidelines or other conditions
          (<strong>"Additional Terms"</strong>)
          in order to participate in certain promotions or activities
          available through our Websites, to obtain certain premium Site
          Content through our Websites, and/or for other reasons. In addition,
          certain Additional Terms will govern your subscription to the
          Services and any purchases you make through the online store. These
          Additional Terms will be posted on the relevant portions of our
          Websites or on the portions of our Websites that describe the
          specific promotions, Content, or activities. These Additional Terms
          are incorporated by reference in this Agreement, and you agree to
          comply with them when you participate in those promotions, purchase
          items from our online stores, or otherwise engage in activities
          governed by such Additional Terms.
        </p>
        <p className="policy__content">
          <strong>33. Modification and Discontinuation.</strong> We reserve
          the right at any time to modify, edit, delete, suspend or
          discontinue, temporarily or permanently the Websites and/or the
          Services, or any portion thereof, with or without notice. You agree
          that we will not be liable to you or to any third party for any such
          modification, editing, deletion, suspension or discontinuance of the
          Websites and/or the Services.
        </p>
        <p className="policy__content">
          <strong>34. Entire Agreement.</strong> This Agreement, together with
          any other terms and conditions referenced herein (including without
          limitation the Privacy Policy and Additional Terms), constitutes the
          entire agreement between you and Gaia and governs your use of the
          Websites and Service, superseding any prior agreements between you
          and Gaia with respect to the Websites and/or the Services.
        </p>
        <p className="policy__content">
          <strong>35. Choice of Law and Forum.</strong> This Agreement and the
          relationship between you and Gaia shall be governed by the laws of
          the State of Colorado without regard to its conflict of law
          provisions. You and Gaia agree to submit to the personal and
          exclusive jurisdiction of the courts located within the county of
          Denver, Colorado.
        </p>
        <p className="policy__content">
          <strong>36. No Waiver.</strong> The failure of Gaia to exercise or
          enforce any right and/or remedy under this Agreement shall not
          constitute a waiver of such right and/or remedy.
        </p>
        <p className="policy__content">
          <strong>37. Statute of Limitations.</strong> You acknowledge and
          agree that regardless of any statute or law to the contrary, any
          claim or cause of action arising out of or related to use of the
          Websites, the Services or this Agreement must be filed within one
          (1) year after such claim or cause of action arose or be forever
          barred.
        </p>
        <p className="policy__content">
          <strong>38. Relationship of the Parties.</strong> You and Gaia
          acknowledge and agree that they are independently contracting
          parties dealing at arm’s length with each other in connection with
          the licensing of intellectual property rights and the provision of
          services. No partnership, joint venture, joint authorship,
          employment, fiduciary, agency or other relationship is created
          between them.
        </p>
        <p className="policy__content">
          <strong>39. Binding on Successors.</strong> This Agreement shall be
          binding on and inure to the benefit of the heirs, executors,
          administrators, licensees, successors and/or assigns of the parties,
          as applicable. For avoidance of doubt, you acknowledge and agree
          that Gaia is fully authorized to assign, sublicense and/or otherwise
          convey and transfer this Agreement and/or any of its rights under
          this Agreement at any time, in its sole and absolute discretion, and
          without compensation of any kind to you.
        </p>
        <p className="policy__content">
          <strong>40. Notices and Questions.</strong> If you have any
          questions regarding this Agreement, please contact us by email at
          info@gaia.com, or by mail at Gaia, Inc. 833 W South Boulder Road,
          Louisville, CO 80027. Except as otherwise specified elsewhere in
          this Agreement, notices to Gaia may be given at the foregoing email
          and postal addresses, and notices to you may be given at the address
          provided to us at the time of registration and/or the purchase of
          goods and services from Gaia. To find more information about our
          service and its features, or if you need assistance with your
          account, please visit the Gaia Help Center on our website. In the
          event of any conflict between these Terms of Use and information
          provided by Customer Service or other portions of our website,
          these Terms of Use will control.
        </p>
      </section>
      {/* Pirvacy Policy section */}
      <section className="policy__section">
        <H1 className="policy__section-title" id="privacy-policy">
          Privacy Policy
        </H1>
        <p className="policy__content policy__content--italic">
          (Including Children’s Online Privacy Protection Policy
        </p>
        <p className="policy__content policy__content--italic">
          and “Your Privacy Rights” for California Residents)
        </p>
        <p className="policy__content policy__content--italic">
          This Privacy Notice was last updated on {privacyLastUpdated} 
        </p>
        <p className="policy__content policy__content--centered policy__content--italic">
          <strong>Your Privacy Matters at Gaia!</strong>
        </p>
        <p className="policy__content">
          Hey there! At Gaia, Inc., we care about your privacy, and we want 
          to be totally upfront about how we handle your information at Gaia. 
          This page explains everything you need to know in simple terms. 
          By using our website and services, you're agreeing to our approach. 
          If you’d like to know more, feel free to click on each of the links 
          provided below, to read our more in-depth <a href="#privacy-notice">Privacy Notice</a>.
        </p>
        <p className="policy__content">
          Special assistance is available for persons with disabilities. 
          If you need assistance accessing our Website, please email us 
          at {infoEmailLink} or call us toll free 
          at (866)-284-8058.
        </p>
        <p className="policy__content">
          <strong>Types of data we collect</strong>
        </p>
        <p className="policy__content">
          <a href="#how-and-why-we-use-your-data">Tell me why</a>
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              Contact details
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Payment information
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Data that identifies you
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Data on how you use Gaia
            </p>
          </li>
        </ul>
        <p className="policy__content">
          <strong>How we use your data</strong>
        </p>
        <p className="policy__content">
          <a href="#how-and-why-we-use-your-data">How exactly?</a>
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              To provide services
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              To keep Gaia running
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              To help us improve Gaia
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              To give personalized member support
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              To send you marketing messages
            </p>
          </li>
        </ul>
        <p className="policy__content">
          <strong>We use cookies</strong>
        </p>
        <p className="policy__content">
          <a href="#cookies">How can I choose?</a>
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              We use only necessary cookies to run and improve the Gaia service
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Our third-party service providers use cookies too for purposes 
              such as analytics and advertising
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              You can turn off cookies, but this will mean that we can't recognize 
              you and we can't resolve issues as easily and we cannot provide 
              you personalized recommendations.
            </p>
          </li>
        </ul>
        <p className="policy__content">
          <strong>When and how we collect data</strong>
        </p>
        <p className="policy__content">
          <a href="#when-and-how-we-collect-data">Am I included?</a>
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              When you communicate with us online, our third-party vendors may receive and 
              store these communications on our behalf. We collect data from people browsing 
              our website and members of Gaia, when:
            </p>
            <ul className="policy__content-list">
              <li>
                <p className="policy__content-list-item">
                  You browse pages of our website
                </p>
              </li>
              <li>
                <p className="policy__content-list-item">
                  Use Gaia through a supported device
                </p>
              </li>
              <li>
                <p className="policy__content-list-item">
                  You receive emails from us
                </p>
              </li>
              <li>
                <p className="policy__content-list-item">
                  You chat with us for member support
                </p>
              </li>
              <li>
                <p className="policy__content-list-item">
                  You opt-in to or interact with our marketing messages
                </p>
              </li>
            </ul>
          </li>
        </ul>
        <p className="policy__content">
          <strong>Know your rights under applicable laws</strong>
        </p>
        <p className="policy__content">
          <a href="#your-privacy-choices-and-rights">What can I do?</a>
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              Access or delete information we hold on you
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Opt-out of marketing communications
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Be forgotten by Gaia
            </p>
          </li>
        </ul>
        <p className="policy__content-list-item">
          If you have any concerns about your privacy at Gaia, please email us
          at {privacyEmailLink} 
        </p>
        <hr/>
        <p id="privacy-notice" className="policy__content policy__content--centered policy__content--italic">
          <strong>Your Privacy Matters at Gaia!</strong>
        </p>
        <p className="policy__content policy__content--centered policy__content--italic">
          <strong>Here's how we protect your data and respect your privacy.</strong>
        </p>
        <p className="policy__content">
          <strong>General Information</strong>
        </p>
        <p className="policy__content">
          The sites to which the following Privacy Notice applies are: www.gaia.com 
          (collectively, “the Websites”). The operator of the Websites is Gaia, Inc., 
          a Colorado corporation, 833 W. South Boulder Road, Louisville, Colorado 80027. 
          You can reach our data protection officer at {privacyEmailLink}. 
        </p>
        <p className="policy__content">
          <strong>Responsibilities</strong>
        </p>
        <p className="policy__content">
          <em>Our responsibility</em>: If you are a Gaia member, or just visiting our website, 
          this privacy notice applies to you. If you are a registered member of Gaia we act 
          as the ‘data controller’ of personal information about you and your use of Gaia.
        </p>
        <p className="policy__content">
          <em>Your responsibility</em>: Read this Privacy Notice
        </p>
        <p id="when-and-how-we-collect-data" className="policy__content">
          <strong>When and how we collect data</strong>
        </p>
        <p className="policy__content">
          From the first moment you interact with Gaia, we are collecting data. 
          Sometimes you provide us with data, sometimes we collect data about you.
          When you communicate with us online, our third-party vendors may receive 
          and store these communications on our behalf.
        </p>
        <p className="policy__content">
          Here’s when and how we collect data:
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              You become a Gaia member
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              You browse any page of our website
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              You use Gaia services through a device
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              You receive emails from us
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              You contact us for member support
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              You opt-in to or interact with our marketing messages
            </p>
          </li>
        </ul>
        <p className="policy__content">
          <strong>Types of data we collect</strong>
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              <em>Identifiers</em>: “Identifiers” covers a broad range of information, 
              including things like name, email address, and IP address. We collect 
              personal information that falls into this category. For example, for 
              subscribers we have an email address and payment information. We collect 
              IP addresses when you connect to our service online. These sorts of 
              identifiers are connected to your Gaia account. There are also identifiers 
              we use for purposes like advertising (third party advertising cookies on 
              our website) that can be used to reach you with promotional messages on 
              other websites and applications.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>Internet or other electronic network activity information</em>: Our service 
              is an online service, so we collect CCPA personal information in this category, 
              such as your interactions and activities within our service.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>Geolocation data</em>: Our streaming application does not collect precise 
              geolocation data from GPS sensors. However, we do collect IP addresses so we can 
              determine your general location in order to give you a better first interaction 
              with our service.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>Inferences</em>: We have a recommendation system that tries to help return you 
              custom titles based on what we feel you will like most.
            </p>
          </li>
        </ul>
        <p className="policy__content">
          <strong>Types of data we do not collect</strong>
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              <em>Sensitive data</em>: We don’t collect any "sensitive data" about you 
              (like racial or ethnic origin, political opinions, religious/philosophical 
              beliefs, trade union membership, genetic data, biometric data, health data, 
              data about your sexual life or orientation, and offences or alleged offences). 
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>Children’s data</em>: Gaia’s website and services are not intended for 
              or directed to users under the age of 18. We do not knowingly or intentionally 
              collect personal information from children under the age of 13 or other minors. 
              Where appropriate, we take reasonable measures to determine that our users are 
              adults of legal age and to inform minors not to submit information to the 
              Websites or the Services, or in response to advertisements.
            </p>
          </li>
        </ul>
        <p id="how-and-why-we-use-your-data" className="policy__content">
          <strong>How and why we use your data</strong>
        </p>
        <p className="policy__content">
          We can only use your data for certain reasons and where we have a legal basis to do so. 
          Here are the reasons for which we process your data:
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              <em>Keeping Gaia running</em>: Login and authentication, processing payments.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>Improving Gaia</em>: Testing features, managing landing pages, 
              traffic optimization and data analysis and research.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>Member Support</em>: Notifying you of any changes to our service, 
              solving issues via support, including any bug fixing.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>Newsletter</em>: Sending you emails and messages about new services, and content.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>Marketing</em>: Identifying you as someone who might wish to buy a Gaia 
              membership or upgrade an existing membership.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>Chatbots</em>: Facilitating the use of third-party AI-powered chatbots.
            </p>
          </li>
        </ul>
        <p className="policy__content">
          We allow others to provide analytics services and serve advertisements on 
          our behalf across the web and in mobile applications. These entities use 
          cookies, web beacons, device identifiers and other technologies to collect 
          information about your use of our Website and other websites and online 
          services, including your IP address, device identifiers, web browser, 
          mobile network information, pages viewed, time spent on pages or in apps, 
          links clicked, and conversion information. This information may be used 
          by us and others to, among other things, analyze and track data, determine 
          the popularity of certain content, deliver advertising and content targeted 
          to your interests on our services and other websites and online services, 
          and better understand your online activity. You can disable cookies used 
          for advertising purposes through our cookie preferences manager. 
          Or, for more information about interest-based ads, including to use ad industry 
          tools to opt out of having your web browsing information used for behavioral 
          advertising purposes, please 
          visit <a target="_blank" href="https://www.aboutads.info/choices">www.aboutads.info/choices</a> (
          if you are in the EU, please 
          visit <a target="_blank" href="https://www.youronlinechoices.eu">www.youronlinechoices.eu</a>). 
          Your mobile device should also include a feature that allows you to opt out 
          of having certain information collected through apps used for behavioral 
          advertising purposes.
        </p>
        <p className="policy__content">
          Except as required by applicable law, we do not respond to or honor “do not track” 
          (a/k/a DNT) signals or similar mechanisms automatically transmitted by web browsers 
          for which we are cannot evaluate your choice.
        </p>
        <p className="policy__content">
          <strong>Sharing of Your Information</strong>
        </p>
        <p className="policy__content">
          Gaia may share your personal information, with the following:
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              Gaia’s parent, affiliates, subsidiaries, or successors (“Gaia Parties”).
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              Third parties who are under obligations of confidentiality with any 
              of the Gaia Parties.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              We may disclose personal information we receive to third-party vendors
              that provide artificial intelligence services that support our Services.
            </p>
          </li>
        </ul>
        <p className="policy__content">
          The following describes some of the ways that your personal information 
          may be disclosed to third parties:
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              We may employ third parties to perform services or functions on our behalf 
              in order to improve our websites, merchandising, marketing and promotional 
              efforts, communications or other services. Those third parties may include 
              authorized contractors, consultants and other companies working with us. 
              They only have access to personal information needed to perform their functions, 
              and they may not share any personal information with others or use it for any 
              other purpose than providing or improving Gaia's services and offerings.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              We may share your information with third parties whom we believe have information 
              of interest to you. In addition, we may share certain non-personal information 
              with third parties for advertising, promotional and other purposes. For example, 
              we may work with third party advertising companies, to serve and track our ads. 
              These third parties may install other cookies. Our advertising partners may use 
              the non-personal information they collect from our websites, in the aggregate, 
              to help us better market and serve our customers
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              We may share your information in connection with the sale, merger, reorganization 
              or change of control of Gaia or the division responsible for the services with 
              which your personally identifiable information is associated or as part of 
              a bankruptcy proceeding.
            </p>
          </li>
        </ul>
        <p className="policy__content">
          This Privacy Notice applies only to the Websites and the Services and does not 
          address the practices of third parties who may collect your personal information. 
          You may visit other websites, through links on the Websites, which may collect, 
          use, and share your personal information in accordance with their own privacy policies. 
          The information practices of those linked websites are not covered by this 
          Privacy Notice, and we encourage you to be very cautious before you disclose 
          your personal information to others. In order to provide you with the information, 
          products or services which you have requested, we may share or transfer your 
          personal information with our parent, affiliates or subsidiaries, or third-party 
          agents acting on their behalf.
        </p>
        <p className="policy__content">
          The Gaia Parties may be obligated to cooperate with various law enforcement 
          inquiries. Each Gaia Party reserves the right to disclose or transfer personal 
          information and non-personal information about you and your activities on our 
          Websites in order to comply with a legal requirement or request from law 
          enforcement or other government officials, administrative agencies or third 
          parties as we, in our sole discretion, determine necessary or appropriate for 
          the administration of justice, or in connection with an investigation of fraud, 
          intellectual property infringements or violations of any other law, rule or 
          regulation, our Terms of Use or other rules or policies of our Websites, 
          the rights of third parties, or an investigation of any other activity that 
          may expose us or you to legal liability, or to investigate any suspected 
          conduct which Gaia in its sole discretion deems improper.
        </p>
        <p id="cookies" className="policy__content">
          <strong>Cookies</strong>
        </p>
        <p className="policy__content">
          We use cookies. Unless you adjust your browser settings to refuse cookies, 
          we (and these third parties) will issue cookies when you interact with Gaia. 
          These may be ‘session’ cookies, meaning they delete themselves when you leave Gaia, 
          or ‘persistent’ cookies which do not delete themselves and help us recognize you 
          when you return so we can provide a tailored service.
        </p>
        <p className="policy__content">
          You can block cookies by activating a setting on your browser allowing you to 
          refuse the setting of cookies. You can also use our cookie banner to manage your 
          preferences. You can also delete cookies through your browser settings. 
          If you use your browser settings to disable, reject, or block cookies 
          (including essential cookies), certain parts of our website or app will not 
          function fully. In some cases, our website or app may not be accessible at all. 
          Please note that where third parties use cookies, we have no control over how 
          those third parties use those cookies.
        </p>
        <p className="policy__content">
          Gaia utilizes Google Analytics for aggregated, anonymized website traffic analysis. 
          To track your Gaia session usage, Gaia places a Google Analytics cookie (_ga) 
          with a randomly generated ClientID in your browser. This ID is anonymized and 
          contains no identifiable information such as email, phone number, name, etc. 
          Gaia uses Google Analytics to track aggregated website behavior, such as what 
          pages you looked at, for how long, etc. This information is important for improving 
          the Gaia user experience and determining Gaia's site effectiveness. 
          If you wish to remove Google Analytics from your site experience, you can install
          the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">
            Google Analytics Opt-Out Browser Add-On
          </a>.
        </p>
        <p id="your-privacy-choices-and-rights" className="policy__content">
          <strong>Your privacy choices and rights</strong>
        </p>
        <p className="policy__content">
          If you are a resident of a jurisdiction with a privacy law that applies to 
          you and Gaia, you may have additional rights regarding your personal information.  
          Such rights apply to users in certain U.S. states (such as under the California 
          Consumer Privacy Act of 2018 and similar laws in other states) or users in the 
          European Union and United Kingdom under the General Data Protection Regulation 
          (GDPR) and similar laws.  This section only applies to those users and is intended 
          to set forth just those rights available under such applicable laws. 
          If you would like to submit a request, you can request that 
          at {privacyEmailLink} and allow 30 days for processing and compliance.
        </p>
        <ol className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              <em>You can choose not to provide us with personal information</em>: If you 
              choose to do this, you can continue to use the website and browse its pages, 
              but you will not be able to become a Gaia member.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>You can turn off cookies</em>: You can block cookies by activating 
              a setting on your browser allowing you to refuse cookies. You can also 
              delete cookies through your browser settings. If you turn off cookies, 
              you can continue to use the Gaia website, but certain services may not 
              work effectively.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>You can opt out of receiving Gaia information</em>: You have the option 
              to opt out of receiving information from Gaia, the website, and the services. 
              The option to opt out will appear at the bottom of every promotional email 
              that is sent. If you no longer wish to take advantage of the websites or 
              the services or receive any form of direct contact from Gaia, whether email, 
              discounts, newsletters, or other promotion offers or materials, contact us 
              at {infoEmailLink} or call (866)-284-8058.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>You have the right to access information we hold about you</em>: We will 
              provide you with the information within 30 days of your request. We’ll tell 
              you if we can’t meet your request for any reason. 
              This includes the right to ask us for:
            </p>
            <ul className="policy__content-list">
              <li>
                <p className="policy__content-list-item">
                  The categories of data we’re processing
                </p>
              </li>
              <li>
                <p className="policy__content-list-item">
                  The purposes of data processing
                </p>
              </li>
              <li>
                <p className="policy__content-list-item">
                  The categories of third parties to whom the data may be disclosed
                </p>
              </li>
              <li>
                <p className="policy__content-list-item">
                  How long the data will be stored (or the criteria used to determine that period)
                </p>
              </li>
              <li>
                <p className="policy__content-list-item">
                  Your other rights regarding our use of your data
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>You have the right to make us correct any inaccurate personal 
                information about you.</em>
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>You can object to us using your data for profiling you or making 
                automated decisions about you</em>: We may use your data to determine 
                whether we should let you know information that might be relevant to you 
                (for example, tailoring emails to you based on your behavior). Otherwise, 
                the only circumstances in which we will do this is to provide the Gaia 
                service to you.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>You have the right to be ‘forgotten’ by us and have us delete your 
                personal information</em>: You can do this by asking us to erase any personal 
                information we hold about you if it is no longer necessary for us to hold the 
                data for purposes of your use of Gaia.
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              <em>You have a right to file a complaint regarding our use of your data</em>: 
              Please tell us first, so we have a chance to address your concerns. Any claims 
              or complaints must be filed a court of competent jurisdiction in the 
              State of Colorado, U.S.A.
            </p>
          </li>
        </ol>
        <p className="policy__content">
          We will not discriminate against you for exercising any of your rights under such laws.
        </p>
        <p className="policy__content">
          <strong>How secure is the data we collect?</strong>
        </p>
        <p className="policy__content">
          We have physical, electronic, and managerial procedures to safeguard and secure 
          the information we collect. We have installed encryption software conforming 
          to the Secure Socket Layers (SSL) protocol to safeguard all of the personal 
          information you send to us. All information is stored on our servers 
          in a secure location. Please remember: 
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              You provide personal information at your own risk: unfortunately, no data 
              transmission is guaranteed to be 100% secure
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              You are responsible of your username and password: keep them secret and safe!
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              If you believe your privacy has been breached, please contact Customer 
              Service immediately at {infoEmailLink}
            </p>
          </li>
        </ul>
        <p className="policy__content">
          <strong>Data Storage and Retention</strong>
        </p>
        <p className="policy__content">
          We will keep your information as long as necessary for our business purposes. 
          Our servers are maintained in the United States of America. By using the Website, 
          you freely and specifically give us your consent to export your information 
          to the USA as specified in this Privacy Policy.  You understand that data stored 
          in the USA may be subject to lawful requests by the courts or law enforcement 
          authorities in the USA.
        </p>
        <p className="policy__content">
          <strong>Changes to this Privacy Policy</strong>
        </p>
        <p className="policy__content">
          We reserve the right, at our discretion, to change, modify, add, or remove 
          portions from this Privacy Policy at any time, provided that any such 
          modifications will only be applied prospectively. We encourage you to periodically 
          review the Website for the latest information on our privacy practices. 
          Your continued use of the Website following the posting of any changes to this 
          Privacy Policy means you accept such changes.
        </p>
        <p className="policy__content">
          <strong>Contact</strong>
        </p>
        <p className="policy__content">
          If you have a question regarding our privacy practices, please contact our 
          Privacy Office at {privacyEmailLink}
        </p>
      </section>
            {/* AI Supplemental Terms section */}
            <section className="policy__section">
        <H1
          className="policy__section-title"
          id="ai-supplemental-terms"
        >
          ARTIFICIAL INTELLIGENCE SUPPLEMENTAL TERMS
        </H1>
        <p className="policy__content">
          The Services may include proprietary and third-party AI-based technology and features
          “AI Technology”, including an AI-powered chatbot feature the “AI Chatbot”.
        </p>
        <p className="policy__content">
          AI Technology may allow users to submit queries or other prompts, and the AI Technology
          will generate and return to you, recommendations, data, or other information or content
          “Output”.
        </p>
        <p className="policy__content">
          AI Technology is subject to the terms and conditions set forth in these Artificial
          Intelligence Supplemental Terms, which are hereby incorporated by reference into our Terms
          of Use.
        </p>
        <p className="policy__content">
          Capitalized terms used but not defined herein have the meanings set forth in our Terms of Use.
        </p>
        <p className="policy__content">
          You acknowledge and agree that, in addition to the limitations and restrictions set forth in
          this Agreement, there are numerous limitations that apply with respect to AI Technology and
          the Output it generates, including that (a) AI Technology can struggle with understanding
          language which can result in Output that is out of context, does not make sense or seems cold
          and impersonal; (b) the data used to train AI Technology can strongly influence the output and
          may, for example, perpetuate biases that are present in the data used for training, which can
          result in Output that is discriminatory or offensive; (c) Output be formulaic or repetitive or
          not accurate, complete, relevant, useful, or error-free; and (d) Output may not be unique,
          novel, exclusive, or otherwise specific to you or your input and other users of the Services
          may receive similar Output via the Services.
        </p>
        <p className="policy__content">
          The Output may be protected or protectable by third party intellectual property or other
          proprietary rights.
        </p>
        <p className="policy__content">
          The Output constitutes Gaia Content under the Agreement.
        </p>
        <p className="policy__content">
          TO THE GREATEST EXTENT PERMITTED BY LAW, (I) GAIA BEARS NO LIABILITY FOR ANY DAMAGE THAT MAY
          RESULT FROM THE SERVICES TO YOU OR ANYONE ELSE ARISING FROM OR RELATING TO YOUR USE OF AI
          TECHNOLOGY AND (II) GAIA MAKES NO REPRESENTATION OR WARRANTY WITH RESPECT TO ANY AI TECHNOLOGY
          OR OUTPUT.
        </p>
        <p className="policy__content">
          OUTPUT IS GENERATED “AS-IS.”
        </p>
        <p className="policy__content">
          You will use independent judgement and discretion before relying on or otherwise using AI
          Technology or Output.
        </p>
        <p className="policy__content">
          AI Technology and Output should not be relied upon for medical, legal, or critical
          decision-making purposes without human oversight.
        </p>
        <p className="policy__content">
          Output is for informational purposes only and is not a substitute for advice from a qualified
          professional.
        </p>
      </section>
      {/* Community Posting Guidelines section */}
      <section className="policy__section">
        <H1
          className="policy__section-title"
          id="community-posting-guidelines"
        >
          Community Posting Guidelines
        </H1>
        <p className="policy__content">
          At Gaia, we believe in awakening to truths and new ways of being.
          In service to our transformative community of more than a half million
          members, we strive to maintain a space that respects dynamic and diverse
          viewpoints that fuel the search for more.
        </p>
        <p className="policy__content">
          With the Internet as an unprecedented tool for connectivity, we’re all
          accountable to each other and responsible for how we show up here.
        </p>
        <p className="policy__content">
          We have built Gaia with incredible dedication to those who want to
          join us to make the world a better place. To this end, we see membership
          to our network and our community as a privilege, not a right. We insist
          that our members demonstrate respect for the people and opinions they
          encounter, remembering that words hold great power.
        </p>
        <p className="policy__content">
          To ensure a safe space for discourse, we will remove comments if they
          are disrespectful toward others in our forum. In circumstances of
          hostility or disrespect toward other members, Gaia, our hosts or guests,
          we may revoke membership entirely.
        </p>
        <p className="policy__content">
          Conscious participation in this community is our collective commitment.
          We thank all of our members for their support to empower the evolution
          of consciousness.
        </p>
      </section>
      {/* Anti Spam Policy section */}
      <section className="policy__section">
        <H1 className="policy__section-title" id="anti-spam-policy">
          Anti Spam Policy
        </H1>
        <p className="policy__content">
          At Gaia we are 100% against spam and unsolicited emails and maintain
          CANSPAM compliance. We do not sell or provide email addresses to any
          unauthorized third party and do not authorize any third party or
          affiliate to misuse products or services created by or associated
          with Gaia in spam or bulk emails. If you feel you have received any
          unwanted emails from us, please contact us immediately and we will
          look into the matter.
        </p>
        <p className="policy__content">
          Gaia prohibits the use of their website and/or services in any
          manner associated with the transmission, distribution or delivery of
          any unsolicited bulk or unsolicited commercial e-mail (ìSpamî). You
          may not use any Gaia services to send Spam. You also may not deliver
          Spam or cause Spam to be delivered to any customers of Gaia.
        </p>
        <p className="policy__content">
          In compliance with the CAN-SPAM Act of 2003 (15 U.S.C. 7701, et
          seq., Public Law No. 108-187, was S.877 of the 108th United States
          Congress), e-mail sent, or caused to be sent, to or through the Gaia
          website or service or on behalf of Gaia may not:
        </p>
        <ul className="policy__content-list">
          <li>
            <p className="policy__content-list-item">
              use or contain false, misleading, invalid or forged headers
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              use deceptive or misleading subject lines
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              use or contain invalid or non-existent domain names;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              employ any technique to otherwise misrepresent, hide or obscure
              any information in identifying the point of origin or the
              transmission path;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              use other means of deceptive addressing;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              use a third partyís internet domain name, or be relayed from or
              through a third partyís equipment, without permission of the
              third party;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              contain false or misleading information in the subject line or
              otherwise contain false or misleading content;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              fail to comply with additional technical standards described
              below;
            </p>
          </li>
          <li>
            <p className="policy__content-list-item">
              otherwise violate our Terms of Use.
            </p>
          </li>
        </ul>
        <p className="policy__content">
          Gaia does not authorize the harvesting, mining or collection of
          e-mail addresses or other information from or through the website or
          its services. Gaia does not permit or authorize others to use the
          Gaia services to collect, compile or obtain any information about
          its customers or subscribers, including but not limited to
          subscriber e-mail addresses. Gaia does not permit or authorize any
          attempt to use its services in a manner that could damage, disable,
          overburden or impair any aspect of any of the services, or that
          could interfere with any other partyís use and enjoyment of any Gaia
          service.
        </p>
        <p className="policy__content">
          If Gaia believes that unauthorized or improper use is being made of
          any service, it may, without notice, take such action as it, in its
          sole discretion, deems appropriate, including blocking messages from
          a particular internet domain, mail server or IP address. Gaia may
          immediately terminate any account on any service which it
          determines, in its sole discretion, is transmitting or is otherwise
          connected with any e-mail that violates this policy.
        </p>
        <p className="policy__content">
          Nothing in this policy is intended to grant any right to transmit or
          send e-mail to, or through, the Gaia website and/or services.
          Failure to enforce this policy in every instance does not amount to
          a waiver of Gaiaís rights.
        </p>
        <p className="policy__content">
          Unauthorized use of any Gaia services in connection with the
          transmission of unsolicited e-mail, including the transmission of
          e-mail in violation of this policy, may result in civil, criminal,
          or administrative penalties against the sender and those assisting
          the sender.
        </p>
        <p className="policy__content">
          Violators of the CAN SPAM Act may be subject to ìcease and desistî
          orders or penalties from the FTC (Federal Trade Commission) of up to
          $11,000 per violation. Criminal prosecution is also possible in the
          case of egregious offenders, which can result in penalties such as
          fines, forfeiture of proceeds and equipment. The worst offenders can
          also be subject to prison time.
        </p>
      </section>
    </div>
  )
  /* eslint-enable */
}

export default EnUs
